/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailslater2Inputs */

const en_companydetailslater2 = /** @type {(inputs: Companydetailslater2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

const de_companydetailslater2 = /** @type {(inputs: Companydetailslater2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Später`)
};

/**
* | output |
* | --- |
* | "Later" |
*
* @param {Companydetailslater2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailslater2 = /** @type {((inputs?: Companydetailslater2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailslater2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailslater2(inputs)
	return de_companydetailslater2(inputs)
});
export { companydetailslater2 as "companyDetailsLater" }